import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../../helpers';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { store } from '../../../../../store/store';
import AclContextProvider from '../../../../Acl/Components/AclContextProvider';
import CaseTypeListHeader from './CaseTypeListHeader';

loadDOMComponent({
	selector: 'react-manager-case-type-list-header',
	callback: ({ container, context, props }: any) => {
		const workplaceId = container.getAttribute('workplaceId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<CaseTypeListHeader workplaceId={workplaceId} />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
